import { ShiftPlanningShiftsPartner } from 'api';

export type BulkForwardFormInput = {
  partners: ShiftPlanningShiftsPartner[];
};

export enum SelectableFor {
  All,
  Some,
  None,
}
